export enum AppMarketAnalyticsPlatform {
  Standalone = 'standalone',
  BusinessManager = 'dashboard',
  Editor = 'editor',
}
